import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

declare var $: any;
@Component({
  selector: 'app-liste',
  templateUrl: './liste.component.html',
  styleUrls: ['./liste.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListeComponent implements OnInit {
  items = Array.from({ length: 100000 }).map((_, i) => `Item #${i}`);

  constructor(public sanitizer: DomSanitizer) {}
  //titre du liste
  @Input() titre: string;
  // liste bouton à afficher en hot du liste
  @Input() listBtn: Array<any> = [];
  // liste colonne du liste
  @Input() columns = { TableRD: [] };
  // disable ou enable les bouton en hot du liste
  @Input() disabled = false;
  // afficher ou non le filtre du liste
  @Input() showFilter = false;
  // afficher ou non le triage du liste
  @Input() showSort = false;
  // le qua ou le composon et afficher dans un *ngFor index du boucle et invoyer
  @Input() index: number;
  // max height du liste
  @Input() maxHeight = 300;
  // min Width du liste
  @Input() minWidth;
  // Width du liste ex 100px, 100%, 100
  @Input() width;
  // footer du liste
  @Input() customFooter;
  // position Scrol à gauche ou à droite ex ltr ou rtl
  @Input() positionScrol = 'ltr';
  // si usePhoneTemplate == true les bouton en hot du liste vent etre masqué est remplacer par une petite icone (sa fonctionne uniquement pour une resolution d'ecrant < au width du liste)
  @Input() usePhoneTemplate: boolean = false;
  // liste de donner à afficher dans la liste
  @Input() dataSource = [];
  // si showHeader == true le head du liste vent etre apparait
  @Input() showHeader: boolean = false;
  // si showChekcboxes == true les chekcboxes du liste vent etre apparait
  @Input() showChekcboxes: boolean = false;

  @Output() output: EventEmitter<any> = new EventEmitter<any>();

  row;
  oldIndex;
  rowIndex;
  textAlign = ['left', 'center', 'right'];
  randomNumber = Math.floor(Math.random() * 901) + 100;
  iconSort = 'arrow_upward';
  flexWrap = false;
  liste = [''];
  ngOnInit(): void {
    // this.columns.TableRD.push({
    //   Lg_Code: "",
    //   Lg_Langue: null,
    //   TableRD_Alligement: 0,
    //   TableRD_Champs: "Travel_Ref",
    //   TableRD_Des: "Ref ",
    //   TableRD_ExpressionH: null,
    //   TableRD_ExpressionR: null,
    //   TableRD_Format: null,
    //   TableRD_Largeur: 100,
    //   TableRD_Ordre: 0,
    //   TableRD_Param1: null,
    //   TableRD_Param2: null,
    //   TableRD_Param3: null,
    //   TableRD_ReadOnly: false,
    //   TableRD_Tri: true,
    //   TableRD_Type: 0,
    //   TableRD_ValDef: null,
    //   TableRD_Valid: null,
    //   TableRD_ValidType: 0,
    //   TableRE_Code: "Travel",
    //   User_Groupe: null,
    //   User_Id: "*",
    //   iconSort: "sort",

    // },
    // {
    //   Lg_Code: "",
    //   Lg_Langue: null,
    //   TableRD_Alligement: 0,
    //   TableRD_Champs: "Travel_version",
    //   TableRD_Des: "version ",
    //   TableRD_ExpressionH: null,
    //   TableRD_ExpressionR: null,
    //   TableRD_Format: null,
    //   TableRD_Largeur: 0,
    //   TableRD_Ordre: 0,
    //   TableRD_Param1: null,
    //   TableRD_Param2: null,
    //   TableRD_Param3: null,
    //   TableRD_ReadOnly: true,
    //   TableRD_Tri: true,
    //   TableRD_Type: 0,
    //   TableRD_ValDef: null,
    //   TableRD_Valid: null,
    //   TableRD_ValidType: 0,
    //   TableRE_Code: "Travel",
    //   User_Groupe: null,
    //   User_Id: "*",
    //   iconSort: "sort",

    // })
    // this.columns.TableRD.splice(5,1)
    // this.columns.TableRD.splice(11,2)

    // if (this.columns)
    //console.log(this.columns.TableRD);

    this.columns.TableRD.forEach((col) => {
      col.iconSort = 'sort';
    });
    window.onresize = () => {
      this.liste[0] = Math.random().toString().substr(2, 5);
    };
  }
  // retourne le width du liste
  getValue(value) {
    if (typeof value == 'number') return value + 'px';
    else if (value) return value;
    else return 'auto';
  }
  // trier la liste
  sort(event, colonne, mode) {
    this.columns.TableRD.forEach((col) => {
      if (col.TableRD_Champs != colonne.TableRD_Champs || !col.iconSort)
        col.iconSort = 'sort';
    });
    if (colonne.iconSort == 'arrow_downward') {
      colonne.iconSort = 'sort';
      this.filterData(event, null, mode);
      return;
    } else if (colonne.iconSort == 'sort') {
      this.dataSource.sort((a, b) => {
        const bandA = a[colonne.TableRD_Champs].toString().toUpperCase();
        const bandB = b[colonne.TableRD_Champs].toString().toUpperCase();
        let comparison = 0;
        if (bandA > bandB) comparison = 1;
        else if (bandA < bandB) comparison = -1;
        return comparison;
      });
      colonne.iconSort = 'arrow_upward';
      return;
    } else if (colonne.iconSort == 'arrow_upward') {
      this.dataSource.sort((a, b) => {
        const bandA = a[colonne.TableRD_Champs].toString().toUpperCase();
        const bandB = b[colonne.TableRD_Champs].toString().toUpperCase();
        let comparison = 0;
        if (bandA < bandB) comparison = 1;
        else if (bandA > bandB) comparison = -1;
        return comparison;
      });
      colonne.iconSort = 'arrow_downward';
      return;
    }
  }
  // retourne le width de tous les colonne du liste
  getWidthCol(): number {
    var espacementEntreDiv = this.columns.TableRD.length * 5;
    var largeurScrol = 20;
    return (
      this.columns.TableRD.map((c) => c.TableRD_Largeur).reduce(
        (a, b) => a + b,
        0
      ) +
      espacementEntreDiv +
      largeurScrol
    );
  }
  // il y a un retour à la ligne dans les colonne => width des colonne < width du zone résérvé au liste
  ifWrap() {
    return false;
    return (
      $('#my-liste-respancive' + this.randomNumber).width() <=
      this.getWidthCol()
    );
  }
  filterData(event?, column?, mode?) {
    if (this.columns && column)
      this.columns.TableRD.forEach((col) => {
        if (col.TableRD_Champs != column.TableRD_Champs) col.iconSort = 'sort';
      });
    const listInput: any = document.getElementsByClassName(
      'inputSearch' + this.randomNumber
    );
    var liste = this.dataSource.filter((row) => {
      var result: boolean = true;
      Array.prototype.forEach.call(listInput, (el) => {
        if (el.value)
          result =
            result &&
            row[el.name]
              .toString()
              .toLowerCase()
              .replace(/é/gi, 'e')
              .replace(/è/gi, 'e')
              .replace(/à/gi, 'a')
              .replace(/ç/gi, 'c')
              .indexOf(
                el.value
                  .toString()
                  .toLowerCase()
                  .replace(/é/gi, 'e')
                  .replace(/è/gi, 'e')
                  .replace(/à/gi, 'a')
                  .replace(/ç/gi, 'c')
              ) >= 0;
      });
      return result;
    });
    if (event)
      this.output.emit({
        event: event,
        action: mode,
        liste: this,
        fitredData: liste,
      });
    return liste;
  }
  getDataSource() {
    return this.filterData();
  }
  getStyleColonne(column) {
    return {
      width: '100%',
      'text-align': this.textAlign[column.TableRD_Alligement],
    };
  }
  getStyle(column) {
    return {
      width: column.TableRD_Largeur + 'px',
      'text-align': this.textAlign[column.TableRD_Alligement],
    };
  }
  clickBtnHeat(event, bouton) {
    this.output.emit({
      event: event,
      bouton,
      action: 'clickBtnHeat',
      liste: this,
    });
  }
  dbClick(event, row, i) {
    this.output.emit({
      event,
      liste: this,
      action: 'dbClick',
      row,
      index: i,
    });
  }
  clickBtnListe(row, colonne, event) {
    this.output.emit({
      event: event,
      row: row,
      colonne: colonne,
      action: 'clickBtnListe',
      liste: this,
    });
  }
  clickColonne(colonne, event) {
    this.output.emit({
      event: event,
      colonne: colonne,
      action: 'clickColonne',
      liste: this,
    });
  }

  clickRow(row, index, event) {
    this.rowIndex = index;
    // if (this.oldIndex != undefined)
    //   $('#row_' + this.randomNumber + '_' + this.oldIndex).removeClass(
    //     'selected-row'
    //   );
    // $('#row_' + this.randomNumber + '_' + index).addClass('selected-row');
    this.row = row;
    this.oldIndex = index;
    this.output.emit({
      event: event,
      row: row,
      index: index,
      action: 'clickRow',
      liste: this,
    });
  }
  isVersionPortable(): boolean {
    if (this.getWidth() < this.minWidth) return true;
    else return false;
  }
  getWidth(): number {
    return window.innerWidth;
  }
  // le composon liste possede un scrole verticale
  isScrol() {
    try {
      if ($('#my-liste-respancive' + this.randomNumber).get(0))
        return (
          $('#my-liste-respancive' + this.randomNumber).get(0).scrollHeight >
          $('#my-liste-respancive' + this.randomNumber).height()
        );
      else return false;
    } catch {
      return false;
    }
  }

  isAllSelectedList: boolean = false;
  toggleAllHCeckBoxes(isAllSelected) {
    var checkboxes = document.getElementsByName('checkboxList');

    if (isAllSelected) {
      for (var i = 0, n = checkboxes.length; i < n; i++) {
        (checkboxes[i] as HTMLInputElement).checked = true;
      }
      this.isAllSelectedList = true;
    } else {
      for (var i = 0, n = checkboxes.length; i < n; i++) {
        (checkboxes[i] as HTMLInputElement).checked = false;
      }
      this.isAllSelectedList = false;
    }
  }

  listSelectedrows = [];
  onSelectCheckBox(event, index) {
    console.log(event.checked);
    console.log(event.source.value);
    const item = event.source.value;
    if (event.checked) {
      this.listSelectedrows.push(item);
    } else {
      var indexTodelet = this.listSelectedrows.indexOf(item);
      this.listSelectedrows.splice(indexTodelet, 1);
      this.rowIndex = null;
    }
    this.output.emit({
      event: event,
      lastrowSelected: event.source.value,
      index: index,
      action: 'CheckedRows',
      liste: this.listSelectedrows,
    });
  }

  getActifClass_selectedList(row, actifClass) {
    return this.listSelectedrows.indexOf(row) !== -1 ? actifClass : '';
  }
}
